import { Brick, registerBrick } from 'olympe';
import BCP from './DM_BCP';
import { getLogger } from '@olympeio/core';
import { ADMIN_FIRST_ACCEPTANCE, BCP_WORKFLOW_STATES } from './BcpWorkflowAuthorizations'
export default class GenerateStepperLabel extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} currentWorkflowItem
     * @param {string} bCPRequest
     * @param {function(string)} setLabelObject
     */
    update($, [currentWorkflowItem, bCPRequest], [setLabelObject]) {

        const SQAperson = bCPRequest.get(BCP.qualityAssuranceProp)?.split(";")?.[1];
        const QAInFactoryPerson = bCPRequest.get(BCP.qaInFactoryProp)?.split(";")?.[1];
        // Function to format the date
        function formatDate(dateString) {
            if (!dateString || isNaN(new Date(dateString))) {
                return "Invalid date"; // Return a fallback value for null or invalid dates
            }
            const date = new Date(dateString);
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            return date.toLocaleDateString('en-US', options);
        }

        // Parsing the requestor's name from the email string
        function getNameFromEmail(string) {
            if (string.includes(';')) {
                const email = string.split(';')[1]; // Get the email part
                return email.split('@')[0].toLowerCase(); // Get the part before '@' and convert to lowercase
            } else {
                return string.split('@')[0].toLowerCase(); // Directly get the part before '@' and convert to lowercase
            }
        }

        // Get the Assignee's name from the email
        const assigneeName = getNameFromEmail(currentWorkflowItem.Assignee);

        // Format the Date from currentWorkflowItem
        const formattedDate = formatDate(currentWorkflowItem['Date Time']);

        // Initialize labelObject
        let labelObject;

        // Function to determine stakeholders based on workflow state
        const getStakeholderData = () => {
            const workflowStat = currentWorkflowItem.InprogressState;
            switch (workflowStat) {
                case BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP:
                    return getNameFromEmail(bCPRequest.get(BCP.businessPartnerProp));
                case BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM:
                    return getNameFromEmail(bCPRequest.get(BCP.procurementManagerProp));
                case BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE:
                    return getNameFromEmail(bCPRequest.get(BCP.technicalApplicationGroupProp));
                case BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1:
                    return `${getNameFromEmail(bCPRequest.get(BCP.qualityAssuranceProp))} and ${getNameFromEmail(bCPRequest.get(BCP.qaInFactoryProp))}`
                case BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2:
                    return getNameFromEmail(getQADueDate(bCPRequest)[1]);
                default:
                    return "Unknown Stakeholder";

            }
        }
        // Function to determine QA due dates QA approver and Approved person based on workflow state
        const getQADueDate = (bcpRequest) => {
            const workflowState = currentWorkflowItem.State;
            const adminAcceptQuality = bcpRequest.get(BCP.adminFirstQualityAcceptanceProp);
            const SQAperson = bcpRequest.get(BCP.qualityAssuranceProp)?.split(";")?.[1];
            const SQADueDate = bcpRequest.get(BCP.sqaCompletionDueDateProp);
            const QAInFactoryDuedate = bcpRequest.get(BCP.qaInFactoryCompletionDueDateProp);
            const QAInFactoryPerson = bcpRequest.get(BCP.qaInFactoryProp)?.split(";")?.[1];

            // Workflow state constants
            const WORKFLOW_STATES = {
                QA_FACTORY_ACCEPTANCE_2: "SQA_QA factory acceptance 2",
                WAITING_COMPLETION_CRITERIA: "Waiting on completion criteria",
            };

            // Function to determine the due date based on approval type
            const findDueDate = (isSQAFirstAcceptance) => {
                let QAWorkflows = ["SQA", "QA"]
                let qaApprover, dueDateProp, approvedQA;
                if (adminAcceptQuality) {
                    // Determine the property based on admin acceptance

                    if (adminAcceptQuality === ADMIN_FIRST_ACCEPTANCE.ACCEPT_AS_SQA) {
                        dueDateProp = isSQAFirstAcceptance ? SQADueDate : QAInFactoryDuedate;
                        qaApprover = isSQAFirstAcceptance ? QAInFactoryPerson : SQAperson;
                        approvedQA = isSQAFirstAcceptance ? QAWorkflows[0] : QAWorkflows[1];
                    } else {
                        dueDateProp = isSQAFirstAcceptance ? QAInFactoryDuedate : SQADueDate;
                        qaApprover = isSQAFirstAcceptance ? SQAperson : QAInFactoryPerson;
                        approvedQA = isSQAFirstAcceptance ? QAWorkflows[1] : QAWorkflows[0];
                    }
                    return [dueDateProp, qaApprover, approvedQA];
                } else {
                    // Determine the property based on the current assignee
                    dueDateProp = currentWorkflowItem.Assignee === SQAperson
                        ? SQADueDate
                        : QAInFactoryDuedate;
                    qaApprover = currentWorkflowItem.Assignee === SQAperson
                        ? QAInFactoryPerson
                        : SQAperson;
                    approvedQA = currentWorkflowItem.Assignee === SQAperson
                        ? QAWorkflows[0] : QAWorkflows[1];
                    return [dueDateProp, qaApprover, approvedQA];
                }
            };

            // Determine and return the due date based on the workflow state
            switch (workflowState) {
                case WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2:
                    getLogger('Workflow steeper').info("Value in QA1:", findDueDate(true));
                    return findDueDate(true);

                case WORKFLOW_STATES.WAITING_COMPLETION_CRITERIA:
                    getLogger('Workflow steeper').info("Waiting value in QA2:", findDueDate(false));
                    return findDueDate(false);

                case "In Progress":
                    return currentWorkflowItem.InprogressState === WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2 ? findDueDate(true) : null

                default:
                    getLogger('Workflow steeper').error("Unhandled workflow state:", workflowState);
                    return null;
            }
        };

        // This will send proper QA if QA in factory and SQA aee same and also non- admin
        const getQADateForSameQA = (bcpRequest, qaIdentifier) => {
            const workflowState = currentWorkflowItem.State;
            const adminAcceptQuality = bcpRequest.get(BCP.adminFirstQualityAcceptanceProp);
            const SQAperson = bcpRequest.get(BCP.qualityAssuranceProp)?.split(";")?.[1];
            const SQADueDate = bcpRequest.get(BCP.sqaCompletionDueDateProp);
            const QAInFactoryDuedate = bcpRequest.get(BCP.qaInFactoryCompletionDueDateProp);
            const QAInFactoryPerson = bcpRequest.get(BCP.qaInFactoryProp)?.split(";")?.[1];

            // Workflow state constants
            const WORKFLOW_STATES = {
                QA_FACTORY_ACCEPTANCE_2: "SQA_QA factory acceptance 2",
                WAITING_COMPLETION_CRITERIA: "Waiting on completion criteria",
            };

            // Function to determine the due date based on approval type
            const findDueDate = (isSQAFirstAcceptance) => {
                let QAWorkflows = ["SQA", "QA"]
                let qaApprover, dueDateProp, approvedQA;
                if (adminAcceptQuality) {
                    // Determine the property based on admin acceptance
                    if (adminAcceptQuality === ADMIN_FIRST_ACCEPTANCE.ACCEPT_AS_SQA) {
                        dueDateProp = isSQAFirstAcceptance ? SQADueDate : QAInFactoryDuedate;
                        qaApprover = isSQAFirstAcceptance ? QAInFactoryPerson : SQAperson;
                        approvedQA = isSQAFirstAcceptance ? QAWorkflows[0] : QAWorkflows[1];
                    } else {
                        dueDateProp = isSQAFirstAcceptance ? QAInFactoryDuedate : SQADueDate;
                        qaApprover = isSQAFirstAcceptance ? SQAperson : QAInFactoryPerson;
                        approvedQA = isSQAFirstAcceptance ? QAWorkflows[1] : QAWorkflows[0];
                    }
                    return [dueDateProp, qaApprover, approvedQA];
                } else {
                    // Determine the property based on the current assignee
                    const isSQA = qaIdentifier === "SQA"
                    dueDateProp = isSQA
                        ? SQADueDate
                        : QAInFactoryDuedate;
                    qaApprover = isSQA
                        ? SQAperson
                        : QAInFactoryPerson;
                    approvedQA = isSQA
                        ? QAWorkflows[0] : QAWorkflows[1];
                    return [dueDateProp, qaApprover, approvedQA];
                }
            };

            // Determine and return the due date based on the workflow state
            switch (workflowState) {
                case WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2:
                    getLogger('Workflow steeper').info("Value in QA1:", findDueDate(true));
                    return findDueDate(true);

                case WORKFLOW_STATES.WAITING_COMPLETION_CRITERIA:
                    getLogger('Workflow steeper').info("Waiting value in QA2:", findDueDate(false));
                    return findDueDate(false);

                case "In Progress":
                    return currentWorkflowItem.InprogressState === WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2 ? findDueDate(true) : null

                default:
                    getLogger('Workflow steeper').error("Unhandled workflow state:", workflowState);
                    return null;
            }
        };


        // Determine labelObject based on workflow state
        let counter = 0;
        switch (currentWorkflowItem.State) {
            case 'Alternative VS suggestion by BP':
                labelObject = {
                    subStep: false,
                    rejectState: false,
                    rejectionNote: null,
                    label: `${getNameFromEmail(bCPRequest.get(BCP.requestorProp))} has created the request on ${formattedDate}`,
                };
                break;

            case 'Alternative VS check by PM':
                labelObject = {
                    subStep: false,
                    rejectState: false,
                    rejectionNote: null,
                    label: `${assigneeName} has accepted the request as BP on ${formattedDate}`,
                };
                break;
            case 'Waiting on completion criteria':
                labelObject = {
                    subStep: true,
                    rejectState: false,
                    rejectionNote: formatDate(getQADueDate(bCPRequest)[0]),
                    label: `${assigneeName} has accepted the request as ${getQADueDate(bCPRequest)[2]} on ${formattedDate}`,
                };
                break;

            case 'SQA_QA factory acceptance 1':
                labelObject = {
                    subStep: true,
                    rejectState: false,
                    rejectionNote: formatDate(bCPRequest.get(BCP.ctagCompletionDueDateProp)),
                    label: `${assigneeName} has accepted the request as CTAG/AG on ${formattedDate}`,
                };
                counter = 0;
                break;

            case 'SQA_QA factory acceptance 2':
                if (QAInFactoryPerson === SQAperson) {
                    if (counter == 0) {
                        labelObject = {
                            subStep: true,
                            rejectState: false,
                            rejectionNote: formatDate(getQADateForSameQA(bCPRequest, "QA")[0]),
                            label: `${assigneeName} has accepted the request as ${getQADateForSameQA(bCPRequest, "QA")[2]} on ${formattedDate}`,
                        };
                        counter = 1;
                    }
                    else {
                        labelObject = {
                            subStep: true,
                            rejectState: false,
                            rejectionNote: formatDate(getQADateForSameQA(bCPRequest, "SQA")[0]),
                            label: `${assigneeName} has accepted the request as ${getQADateForSameQA(bCPRequest, "SQA")[2]} on ${formattedDate}`,
                        };
                        counter = 0;
                    }
                } else {
                    labelObject = {
                        subStep: true,
                        rejectState: false,
                        rejectionNote: formatDate(getQADueDate(bCPRequest)[0]),
                        label: `${assigneeName} has accepted the request as ${getQADueDate(bCPRequest)[2]} on ${formattedDate}`,
                    }
                    counter = 0;
                }
                break;
            case 'In Progress':
                labelObject = {
                    subStep: false,
                    rejectState: false,
                    rejectionNote: null,
                    label: `${getStakeholderData()} has to accept the request`,
                };
                break;

            case 'Not started':
                labelObject = {
                    subStep: false,
                    rejectState: false,
                    rejectionNote: null,
                    label: `Not started`,

                };
                break;

            case 'CTAG acceptance':
                labelObject = {
                    subStep: false,
                    rejectState: false,
                    rejectionNote: null,
                    label: `${assigneeName} has accepted the request as PM and confirmed the Alternative VS code ${bCPRequest.get(BCP.alternativeVendorCodeProp)} on ${formattedDate}`,
                };
                break;

            case 'Waiting validation':
                labelObject = {
                    subStep: false,
                    rejectState: false,
                    rejectionNote: null,
                    label: `Waiting for automatic validation. BCP request will be set to 'complete' status once the alternative vendor QIR has been detected in the backend.`,
                };
                break;

            case 'Rejected':
                labelObject = {
                    subStep: true,
                    rejectState: true,
                    rejectionNote: bCPRequest.get(BCP.rejectedNoteProp), // Use the rejection note from bCPRequest
                    label: `${assigneeName} has rejected the request on ${formattedDate}`,
                    rejectionReasonCommet: bCPRequest.get(BCP.rejectionReasonCommentProp)
                };
                break;

            case 'Completed':
                labelObject = {
                    subStep: false,
                    rejectState: false,
                    rejectionNote: null,
                    label: `Request completed automatically on ${formattedDate}`,
                };
                break;

            default:
                labelObject = {
                    subStep: false,
                    rejectState: false,
                    rejectionNote: null,
                    label: `Unknown state: ${currentWorkflowItem.State}`,
                };
        }

        setLabelObject(labelObject);
        getLogger('Workflow steeper').info(labelObject);
    }

}

registerBrick('019376a1abf9f9439f30', GenerateStepperLabel);
